import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { IonicModule } from '@ionic/angular';
import { AzzurroTable, SimpleButtonComponent, TitleContentComponent } from 'ngx-zcs-components';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { AzzurroHubDetailsComponent } from './azzurro-hub-details.component';
import { AzzurroHubRescanComponent } from '../components/azzurro-hub-rescan/azzurro-hub-rescan.component';

@NgModule({
  declarations: [
    AzzurroHubDetailsComponent,
  ],
  imports: [
    AzzurroHubRescanComponent,
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    MatIconModule,
    MatProgressSpinnerModule,
    SimpleButtonComponent,
    TitleContentComponent,
],
  exports: [
    AzzurroHubDetailsComponent,
  ],
})
export class AzzurroHubDetailsModule { }
